import { Button, IconButton, Input, InputAdornment, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { setLabourFilterKey, setSelection } from '../../store/actions';
import SelectDialog from '../SelectDialog';
import LabourTable from './labour';
import SelectedChip from './selected';

const useStyles = makeStyles(theme => ({
  root: {
    color: 'white',
    padding: '2px'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    width: '97%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  }
}));

function SelectLabour(props) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const defectsTable = props.defects && props.defects.defectsTable;
  const pickedDefect = defectsTable && props.defect != null ? defectsTable[props.defect] : null;
  let mappedLabour = null;
  if (pickedDefect && pickedDefect.Labours && pickedDefect.Labours.length > 0) {
      mappedLabour = pickedDefect.Labours[0];
  }
  const handleEntering = () => {
    props.setLabourFilterKey('');

  };
  return (
    <SelectDialog
      open={props.open}
      title={`${props.defect} ${t('Hizmet')} ${props.title}`}
      onClose={props.onClose}
      onEntering={handleEntering}
      actions
      SearchField={
        <div className={classes.fields}>
          <Input
            onChange={event => props.setLabourFilterKey(event.target.value)}
            value={props.labours.filterKey}
            endAdornment={
              <InputAdornment position="end">
                <IconButton edge="end">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
            aria-describedby="standard-weight-helper-text"
            placeholder={t('IscilikArama')}
          />
        </div>
      }
      SelectedItems={<SelectedChip defect={props.defect} />}
     >
     {mappedLabour && (
       <Typography
        variant="body2"
         style={{ margin: '8px 0', color: 'blue' }}
      >
         {t('LabourSelectedForDefect')
            .replace('@Labour', mappedLabour.LabourDesc)
            .replace('@Defect', pickedDefect.DefectDesc)}
       </Typography>
    )}

   <LabourTable
  defect={props.defect}
  garantiTipi={props.garantiTipi}
  ReceiptNo={props.ReceiptNo}
  
/>
  
    </SelectDialog>
  );
}

const mapStateToProps = state => ({
  defects: state.defectReducer,
  labours: state.labourReducer
});

const mapDispatchToProps = {
  setSelection,
  setLabourFilterKey
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectLabour);
